export default "__VITE_ASSET__Bjj_Z6Rv__"